const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : LatencyWatcher
 */

function LatencyWatcher(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

LatencyWatcher.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_LatencyWatcher = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const LatencyWatcher_null_Idle = new StateJS.State('Idle', this._statemachine).entry(() => {
    this.LatencyWatcher_highLatencyGauge_var = 0;
    this.LatencyWatcher_latency_var = 0;
  });
  const LatencyWatcher_null_Checking = new StateJS.State('Checking', this._statemachine).entry(() => {
    this.computeLatency();
    if ((this.LatencyWatcher_latency_var > this.LatencyWatcher_maxLatency_var)) {
      if (this.LatencyWatcher_highLatencyGauge_var < this.LatencyWatcher_maxLatencyGague_var) {
        this.LatencyWatcher_highLatencyGauge_var += 1;
      }
      if (this.LatencyWatcher_highLatencyGauge_var >= this.LatencyWatcher_maxLatencyGague_var) {
        this.bus.emit('latency', new Event.HighLatency_LatencyWatcherMsg(this.name, 'latency', this.LatencyWatcher_latency_var));
      }
    } else {
      if (this.LatencyWatcher_highLatencyGauge_var > 0) {
        this.LatencyWatcher_highLatencyGauge_var -= 1;
      }
      if (this.LatencyWatcher_highLatencyGauge_var === 0) {
        this.bus.emit('latency', new Event.NormalLatency_LatencyWatcherMsg(this.name, 'latency', this.LatencyWatcher_latency_var));
      }
    }
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.LatencyWatcher_workTimerId_var, 5000));
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.LatencyWatcher_workTimerId_var));
  });
  _initial_LatencyWatcher.to(LatencyWatcher_null_Idle);
  LatencyWatcher_null_Checking.to(LatencyWatcher_null_Checking).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.LatencyWatcher_workTimerId_var));
  this._statemachine.on(Event.VideoElement).when((videoElement) => videoElement.port === 'html5VideoElement' && videoElement.type === 'videoElement').effect((videoElement) => {
    this.LatencyWatcher_video_var = videoElement.video;
  });
  LatencyWatcher_null_Idle.to(LatencyWatcher_null_Checking).on(Event.Start_LatencyWatcherMsg).when((start) => start.port === 'latency' && start.type === 'start');
  LatencyWatcher_null_Checking.to(LatencyWatcher_null_Idle).on(Event.Stop_LatencyWatcherMsg).when((stop) => stop.port === 'latency' && stop.type === 'stop');
};
LatencyWatcher.prototype.timestamp = function () {
  return Date.now();
};

LatencyWatcher.prototype.setMaxLatency = function (LatencyWatcher_setMaxLatency_newMaxLatency_var) {
  this.LatencyWatcher_maxLatency_var = LatencyWatcher_setMaxLatency_newMaxLatency_var;
};

LatencyWatcher.prototype.computeLatency = function () {
  if ((this.LatencyWatcher_video_var && this.LatencyWatcher_video_var.buffered && this.LatencyWatcher_video_var.buffered.length > 0)) {
    this.LatencyWatcher_bufferedTime_var = (this.LatencyWatcher_video_var.buffered.end(0));
    this.LatencyWatcher_currentTime_var = (this.LatencyWatcher_video_var.currentTime);
    if (this.LatencyWatcher_bufferedTime_var >= this.LatencyWatcher_currentTime_var) {
      this.LatencyWatcher_latency_var = this.LatencyWatcher_bufferedTime_var - this.LatencyWatcher_currentTime_var;
      this.bus.emit('statusInput', new Event.Duration_StatusMsg(this.name, 'statusInput', Enum.DurationTypes_ENUM.LATENCY, this.LatencyWatcher_latency_var * 1000));
    }
  }
};

LatencyWatcher.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

LatencyWatcher.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

LatencyWatcher.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

LatencyWatcher.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

LatencyWatcher.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tworkTimerId = ${this.LatencyWatcher_workTimerId_var}`;
  result += `\n\tbufferedTime = ${this.LatencyWatcher_bufferedTime_var}`;
  result += `\n\thighLatencyGauge = ${this.LatencyWatcher_highLatencyGauge_var}`;
  result += `\n\tvideo = ${this.LatencyWatcher_video_var}`;
  result += `\n\tmaxLatencyGague = ${this.LatencyWatcher_maxLatencyGague_var}`;
  result += `\n\tcurrentTime = ${this.LatencyWatcher_currentTime_var}`;
  result += `\n\tmaxLatency = ${this.LatencyWatcher_maxLatency_var}`;
  result += `\n\tlatency = ${this.LatencyWatcher_latency_var}`;
  result += '';
  return result;
};

module.exports = LatencyWatcher;
